import { effect, inject, Injectable, signal } from '@angular/core'
import { MAP } from '@bases/base.token'
import { GEOSERVER_URL } from '@core/constants/constant.data'
import { HECTARE } from '@core/constants/scale.data'
import { TileLayerOption } from '@core/models/layers.model'
import { ScaleLevel } from '@core/models/scale-level.model'
import { environment } from '@env/environment'
import * as L from 'leaflet'
import { BehaviorSubject } from 'rxjs'
import { ToasterService } from './toaster.service'

@Injectable({
  providedIn: 'root',
})
export class SelectionScaleService {
  private readonly _map = inject<BehaviorSubject<L.DrawMap>>(MAP)
  private readonly _toasterService = inject(ToasterService)
  scaleLevels: ScaleLevel[] = environment.scaleRequest
  currentScaleLevel$ = signal<ScaleLevel>(
    this.scaleLevels.find((scaleLevel) => scaleLevel.displayName === environment.scaleInitial) ?? {
      id: 1,
      displayName: HECTARE,
      apiName: 'ha',
      geoServer: '',
      payloadScale: 'hectare',
    },
  )
  currentScaleLevelLeafletLayer = null

  constructor() {
    effect(() => {
      const scaleLevel = this.currentScaleLevel$()
      const map = this._map.getValue()

      if (!map) {
        return
      }

      // Remove previous scale level layer
      if (this.currentScaleLevelLeafletLayer != null) {
        map.removeLayer(this.currentScaleLevelLeafletLayer)
        this.currentScaleLevelLeafletLayer = null
      }

      // Add new scale level layer if not HECTARE
      if (scaleLevel?.displayName != HECTARE) {
        this.addBorderOnMap()
      }
    })
  }

  addBorderOnMap() {
    const map = this._map.getValue()
    const layer = this._getTiLayer(this.currentScaleLevel$().option)
    map.addLayer(layer)
    this.currentScaleLevelLeafletLayer = layer
  }

  setSelectableArea(displayName: string) {
    // Add scale level layer on map
    const newScaleLevel = this.scaleLevels.find(
      (scaleLevel) => scaleLevel.displayName == displayName,
    )
    if (newScaleLevel) {
      this.currentScaleLevel$.set(newScaleLevel)
    }
  }

  //@ToDo: check with ~ same method in layer service
  private _getTiLayer(option: TileLayerOption): any {
    const wms_request = L.tileLayer.wms(GEOSERVER_URL, option)
    wms_request.on('load', () => {})
    wms_request.on('tileunload', () => {})
    wms_request.on('tileloadstart', () => {})
    wms_request.on('tileerror', (error) => {
      console.error('getTileLayer', error)
      this._toasterService.openSnackBarError('Error loading tiles for ' + option.layers)
    })
    wms_request.on('loading', () => {})

    return wms_request
  }
}
